/**
 * Reference: https://github.com/dimitar-nikovski/use-ref-scroller
 * https://stackoverflow.com/questions/49820013/javascript-scrollintoview-smooth-scroll-and-offset
 */
import {useRef, useCallback } from 'react'
const fixedHeaderOffset = 130

function scrollToPercent(el) {
    const rectY = el.current.getClientRects()[0].y;
    window.scrollTo({
      top:  rectY + window.pageYOffset - fixedHeaderOffset,
      behavior: 'smooth'
    });
}

export const useRefScroller = () =>{
    const elRef = useRef(null);
    const scroll = useCallback(() => {
        if (elRef.current) {
        scrollToPercent(elRef);
        }
    }, [elRef.current]);
    return { elRef, scroll };
}